/*!
 * Spotlight Product JS v1.0
 * Sensy Premium
 */

(() => {
  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  document.querySelectorAll(".spotlight").forEach((section) => {

    /* Fade In */
    if (!prefersReduced && "IntersectionObserver" in window) {
      section.style.opacity = "0";
      section.style.transform = "translateY(18px)";
      section.style.transition =
        "opacity .6s ease, transform .6s ease";

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              section.style.opacity = "1";
              section.style.transform = "translateY(0)";
              observer.disconnect();
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observer.observe(section);
    }

    /* Countdown */

    const timer = section.querySelector(".spotlight__timer");

    if (!timer) return;

    const end = timer.dataset.end;

    if (!end) {
      timer.style.display = "none";
      return;
    }

    const target = new Date(end).getTime();

    function render() {
      const diff = target - Date.now();

      if (diff <= 0) {
        timer.innerHTML =
          '<span class="spotlight__expired">Kampanya sona erdi</span>';
        clearInterval(interval);
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      timer.innerHTML = `
        <div class="sp-unit">
          <strong>${days}</strong>
          <span>Gün</span>
        </div>

        <div class="sp-unit">
          <strong>${hours}</strong>
          <span>Saat</span>
        </div>

        <div class="sp-unit">
          <strong>${minutes}</strong>
          <span>Dk</span>
        </div>

        <div class="sp-unit">
          <strong>${seconds}</strong>
          <span>Sn</span>
        </div>
      `;
    }

    render();

    const interval = setInterval(render, 1000);
    /* Variant Preview */

const variants = section.querySelectorAll(".spotlight__variant");

if (variants.length) {
const variantName = section.querySelector(".spotlight__variant-name");
const spotlightImage = section.querySelector(".spotlight__image");
  variants.forEach((variant) => {

    variant.addEventListener("click", () => {

      variants.forEach((item) =>
        item.classList.remove("is-active")
      );

      variant.classList.add("is-active");
      if (variantName) {
    variantName.textContent = variant.dataset.name;
}
if (spotlightImage && variant.dataset.image) {

    spotlightImage.style.transition = "opacity .18s ease";
    spotlightImage.style.opacity = "0";

    setTimeout(() => {

    spotlightImage.src = variant.dataset.image;
    spotlightImage.srcset = "";
    spotlightImage.removeAttribute("srcset");

    spotlightImage.style.opacity = "1";

}, 180);

}
    });

  });

}
  });
})();